import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS, stanNotify } from '@/lib';
import { transferAffiliateLink } from '@/lib/api/affiliate-links';
import type { TransferLinkPayload } from '../types/affiliateLinks.types';

export function useTransferAffiliateLink() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: TransferLinkPayload) => transferAffiliateLink(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.MY_AFFILIATE_LINKS] });
            stanNotify({
                type: 'success',
                title: 'Link Transferred',
                text: 'Affiliate link has been successfully transferred',
                duration: 3000,
            });
        },
        onError: (error: { response?: { data?: { message?: string } } }) => {
            stanNotify({
                type: 'error',
                title: 'Transfer Failed',
                text: error.response?.data?.message || 'Failed to transfer affiliate link',
                duration: 3000,
            });
        },
    });
}
